"use client";

import { useEffect, useRef, useState } from "react";
import card1 from "../../public/solar-panel1.png";
import card2 from "../../public/solar-panel2.png";
import card3 from "../../public/solar-panel3.png";
import Image from "next/image";
import CountUp from "react-countup";

export default function SolarCard() {
  const cards = [
    { card_img: card1, title: "Years of Experience", suffix: "+", number: 7 },
    { card_img: card2, title: "Satisfied Customers", suffix: "k+", number: 7.2 },
    { card_img: card3, title: "Successful Installation", suffix: "k+", number: 4.5 },
  ];

  return (
    <div className="w-full flex justify-center items-center md:px-5 2xl:px-0  xl:py-4 2xl:py-4 md:py-4 py-10">
      <div className="w-full max-w-[1400px] grid grid-cols-1 md:grid-cols-1 xl:grid-cols-3 gap-6">
        {cards.map((data, index) => (
          <CountUpCard key={index} data={data} />
        ))}
      </div>
    </div>
  );
}

function CountUpCard({ data }) {
  const [start, setStart] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStart(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (cardRef.current) observer.observe(cardRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      className="relative w-full h-[16rem] md:h-[20rem] xl:h-[12.5rem] 2xl:h-[12.5rem] overflow-hidden"
    >
      <Image src={data.card_img} alt="card-img" fill className="object-cover" />
      <div className="absolute inset-0 bg-black/30 rounded-lg"></div>
      <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
        <h2 className="text-[40px] text-white font-bold">
          {start && (
            <CountUp
              start={0}
              end={data.number}
              duration={3}
              decimals={data.number % 1 !== 0 ? 1 : 0}
              easingFn={(t, b, c, d) => c * (1 - Math.pow(2, -10 * t / d)) + b}
            />
          )}
          {data.suffix}
        </h2>
        <p className="text-xl md:text-2xl text-white">{data.title}</p>
      </div>
    </div>
  );
}
